import { r as require$$0 } from '../../tslib/tslib.es6-LMiJArAJ.js';
import { r as requireTypes } from './types-CRX0TP5l.js';

var noParser = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports._Parser = exports.parse = void 0;
	var tslib_1 = require$$0;
	function parse() {
	    throw new Error("You're trying to format an uncompiled message with react-intl without parser, please import from 'react-intl' instead");
	}
	exports.parse = parse;
	tslib_1.__exportStar(requireTypes(), exports);
	exports._Parser = undefined; 
} (noParser));

export { noParser as n };
//# sourceMappingURL=no-parser-BWX__HiN.js.map
